<template>
    <div>
        <button :class="getButtonClass()" @click="googleSignup">
            <div class="button__google--icon">
                <common-icon name="google" size="medium"></common-icon>
            </div>
            <span>{{ $t('forms.auth.signup.buttons.continue_with_google') }}</span>
        </button>
    </div>
</template>

<script>
    import AuthAPI from 'api/AuthAPI'
    import LoginType from 'enums/login_type.enum'
    import RoutesEnum from 'enums/routes.enum'
    import { googleTokenLogin } from 'vue3-google-login'
    import Store from '~/store'

    export default {
        methods: {
            checkIsAppBoundDomain() {
                if (typeof window === 'undefined' || typeof navigator === 'undefined') {
                    return false
                }
                return navigator.userAgent.includes('WKWebView') || navigator.userAgent.includes('iPhone')
            },
            googleSignup() {
                if (this.$auth.isSubdomainActive() && !Store.getters['data/getSubdomainCompany'].googleLoginEnabled) {
                    return
                }

                if (this.checkIsAppBoundDomain()) {
                    try {
                        window.webkit.messageHandlers.socialAuth.postMessage('google')
                        return
                    } catch (error) {
                        console.error({ message: 'Something went wrong', data: error })
                    }
                }
                googleTokenLogin().then((response) => {
                    AuthAPI.loginGoogle({
                        accessToken: response.access_token,
                        language: this.$i18n.locale,
                    })
                        .then((res) => {
                            this.createSession(res.payload)
                        })
                        .catch((err) => {
                            console.error({ message: 'Something went wrong', data: err })
                        })
                })
            },

            createSession(data) {
                this.$auth.createSession({
                    accessToken: data.access_token,
                    refreshToken: data.refresh_token,
                    loginType: LoginType.GOOGLE,
                })

                this.$router.push({ name: RoutesEnum.INDEX.HOME })
            },

            getButtonClass() {
                return {
                    button__google: true,
                    'button__google-disabled':
                        this.$auth.isSubdomainActive() && !Store.getters['data/getSubdomainCompany'].googleLoginEnabled,
                }
            },
            handleExternalSocialAuth(event) {
                const { accessToken } = event.detail

                AuthAPI.loginGoogle({
                    accessToken,
                    language: this.$i18n.locale,
                })
                    .then((res) => {
                        this.createSession(res.payload)
                    })
                    .catch((err) => {
                        console.error({ message: 'Something went wrong', data: err })
                    })
            },
        },

        mounted() {
            window.addEventListener('external-social-auth', this.handleExternalSocialAuth)
        },
        destroyed() {
            window.removeEventListener('external-social-auth', this.handleExternalSocialAuth)
        },
    }
</script>
